import { render, staticRenderFns } from "./SaveResponseModal.vue?vue&type=template&id=21560b06"
import script from "./SaveResponseModal.vue?vue&type=script&lang=js"
export * from "./SaveResponseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports